import axios from "axios";
import { Configuration } from "./apiclient";
import { AppBridgeState, ClientApplication } from "@shopify/app-bridge";

// axios.interceptors.response.use(
//     (response) => response,
//     (error) => {
//         if (error.status === 401 || error.response.status === 401 || error.status === 403 || error.response.status === 403) {
//             window.location.href = "/account/login"
//         }
//         return Promise.reject(
//             error || "Something went wrong"
//         )
//     }
// );


export const apiConfig = {
    baseUrl: window.location.protocol,
    configuration: new Configuration(),
};

export const shopifyAppBridge = {
    app: {} as any,
    host: '' as string
}
